// --------------------------------------------------------
// src/views/themeCollection.view.js
//
// Manage the view/template of a themeCollection object
//
//
// --------------------------------------------------------
"use strict";

// The view for the book collection
const ThemeCollectionView = Backbone.View.extend({
	// The DOM element that will be created
	tagName: "div",

	initialize: function() {
		this.listenTo(this.collection, "update reset destroy", this.render);
	},

	// Render the template for every themes in the collection
	render: function() {
		// Render a view for every books in the collection
		this.$el.empty();
		this.collection.each(this.addTheme, this);

		return this;
	},

	// Append a new book template
	addTheme: function(theme) {
		// Create the view with the given book object
		var tc = new ThemeComponent({ model: theme });
		// Returns a shuffled book collection from a given theme
		var coll = new BookCollection(_.shuffle(window.BOOKCOLLECTION.search(theme.toJSON().name, ["theme"]).models).slice(0, 4));
		var bcv = new BookCollectionView({ collection: coll });
		this.$el.append(tc.render().el);
		this.$el.append(bcv.render().el);
	}
});
